import { Pagination } from '@/constants/pagination';
import { CursorPaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ReceivingAccountState = {
  dataReceivingAccount: ReceivingAccountItem[];
  dataReceivingAccountDetail?: ReceivingAccountItem;
  dataReceivingAccountSummary?: ReceivingAccountSummaryType;
  dataReceivingAccountCurrency: ReceivingAccountCurrencyType[];
  pagination: CursorPaginationAPI;
};

export const receivingAccountInitialState: ReceivingAccountState = {
  pagination: {
    nextCursor: null,
    previousCursor: null,
    hasMore: false,
    hasPrevious: false,
    pageSize: Pagination.Size,
  },
  dataReceivingAccount: [],
  dataReceivingAccountCurrency: [],
};

export const slice = createSlice({
  name: 'receivingAccounts',
  initialState: receivingAccountInitialState,
  reducers: {
    setListReceivingAccountsAction(
      state,
      {
        payload,
      }: PayloadAction<{
        dataReceivingAccount: ReceivingAccountItem[];
        pagination?: CursorPaginationAPI;
      }>,
    ) {
      state.dataReceivingAccount = payload.dataReceivingAccount;
      state.pagination = payload.pagination ?? state.pagination;
    },

    setReceivingAccountsCurrencyAction(
      state,
      { payload }: PayloadAction<{ dataReceivingAccountCurrency: ReceivingAccountCurrencyType[] }>,
    ) {
      state.dataReceivingAccountCurrency = payload.dataReceivingAccountCurrency;
    },

    setReceivingAccountsDetailAction(
      state,
      { payload }: PayloadAction<{ dataReceivingAccountDetail: ReceivingAccountItem }>,
    ) {
      state.dataReceivingAccountDetail = payload.dataReceivingAccountDetail;
    },
    setReceivingAccountSummaryAction(
      state,
      { payload }: PayloadAction<{ dataReceivingAccountSummary: ReceivingAccountSummaryType }>,
    ) {
      state.dataReceivingAccountSummary = payload.dataReceivingAccountSummary;
    },
  },
});

export const {
  setListReceivingAccountsAction,
  setReceivingAccountsCurrencyAction,
  setReceivingAccountsDetailAction,
  setReceivingAccountSummaryAction,
} = slice.actions;

export default slice.reducer;
